import type { ContractAdditionalFilter } from '@vy/types';
import { ContractAdditionalFilterSchema } from '@vy/types';
import { useStateParams } from '../../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../../utils/params-formatting';

export function useAdditionalFiltersParam(defaultValue: ContractAdditionalFilter[] = []) {
  return useStateParams<ContractAdditionalFilter[]>(
    defaultValue,
    'additionalFilters',
    serializeStringArrayParam,
    deserializeContractAdditionalFiltersArrayParam,
  );
}

function deserializeContractAdditionalFiltersArrayParam(
  contractAdditionalFiltersArrayStringified: string,
): ContractAdditionalFilter[] | null {
  const additionalFilters = contractAdditionalFiltersArrayStringified.split(',');

  return ContractAdditionalFilterSchema.array().parse(additionalFilters);
}
